export interface Deal {
    id: number
    value: number
    netValue: number
    title: string
    customer: Customer
    lines: DealLine[];
    payments: DealPayment[];
    type: DealType;
    currentInstalment: number;
    instalments: number;
}

export enum DealType {
    NEW_CUSTOMER,
    RENEWAL,
    UPSELLING,
    MANUAL,
    NO_RENEWAL,
    OVERDUE
}

export interface Customer {
    id?: number;
    vatNumber: string;
    name: string;
    legalName: string;
    phone: string;
    email: string;
    officialEmail: string;
    address: string;
    city: string;
    country: string;
    zipCode: string;
    streetNumber: string;
    taxPolicy: CustomerTaxCategory;

    locality?: string;
    operatingPeriod?: string;
    venueTier?: string;
    venueType?: string;
}

export enum CustomerTaxCategory {
    UNSPECIFIED = 0,
    NORMAL = 1,
    SPECIAL = 2,
    EU = 3,
    NOT_EU = 4,
}

export interface DealLine {
    id: number
    crmId: number
    productName: string
    productDescription: string
    itemPrice: number
    totalPrice: number
    discount: number
    discountPercentage: number
    netPrice: number
    vat: number
    quantity: number
}

export interface DealPayment {
    datePaid: string,
    dueDate: string,
    amount: number,
    index: number,
    done: boolean,
    isProcessing: boolean
}

export interface CustomerMasterData {
    localities: OptionValue[];
    venueTypes: OptionValue[];
    enterpriseTypes: OptionValue[];
    operatingPeriods: OptionValue[];
    venueTiers: OptionValue[];
}

export interface OptionValue {
    display: string;
    key: string;
}
